import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { clearUserToken } from '@features/userTokenSlice';

import { Button, Modal } from 'antd';

import { tConsume } from 'TRANSLATION';
import Wrapper from '@molecules/wrappers/RobotWrapper';
import RegistrationBlockWrapper from '@molecules/wrappers/RegistrationBlockWrapper';

import { Shield } from 'IMAGE';
import './logout.less';

class Logout extends Component {
  componentDidMount() {
    const { userType, clearUserToken, userToken } = this.props;

    if (userType === userToken.tokenType) {
      clearUserToken();
      Modal.destroyAll();
    }
  }

  redirectToStart() {
    this.props.history.replace('/');
  }

  render() {
    const { userType } = this.props;

    return (
      <Wrapper isLogin={true}>
        <RegistrationBlockWrapper userType={userType}>
          <>
            <div className='logout-content'>
              <Shield />
              <h1 className='title'>You have been logged out. Thank you for the visit!</h1>
              <p>For security reasons, please close the browser window.</p>
            </div>

            <Button type={'primary'} htmlType={'button'} size={'large'} onClick={() => this.redirectToStart()} block>
              GOT IT
            </Button>
          </>
        </RegistrationBlockWrapper>
      </Wrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userToken: state.userToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearUserToken: (path) => dispatch(clearUserToken(path)),
  };
};

export default tConsume(connect(mapStateToProps, mapDispatchToProps)(withRouter(Logout)));

Logout.propTypes = {
  userType: PropTypes.string.isRequired,
  route: PropTypes.string.isRequired,
  clearUserToken: PropTypes.func.isRequired,
  userToken: PropTypes.object,
  redirectPath: PropTypes.string,
  t: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};
